import React from "react"
import Spinner from "./spinner"

interface Props {
  isLoading: boolean
}

const SpinnerLoader: React.FunctionComponent<Props> = ({
  isLoading,
  children,
}) => {
  if (isLoading) {
    return <Spinner />
  }

  return <>{children}</>
}

export default SpinnerLoader
